export default {
  label: {
    id: 'services_bouygues_offers_include_item9_title',
    defaultMessage: 'Option de contrôle parental gratuite',
  },
}
